import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scToGermanCurrencyFormat',
  standalone: true,
})
export class ToGermanCurrencyFormatPipe implements PipeTransform {
  transform(value: string, decimalSeparator: string = ','): string {
    if (!value) {
      return '0,-';
    }

    let [euros, cents] = value.split('.');
    cents = !cents || cents === '00' ? '-' : cents;

    return euros + decimalSeparator + cents;
  }
}
